<template>
  <div>
    <a-page-header
        style="border: 1px solid rgb(235, 237, 240)"
        :title="$t('user.userManage')"
    >
      <template #extra>
        <add-new-user @createSuccess="initPage"/>
      </template>
    </a-page-header>
    <a-table :columns="cols" :data-source="visitList">
      <template #index="{ index }">
        {{ index + 1 }}
      </template>
      <template #userName="{record}">
        {{ record.user.name }}
      </template>
      <template #userGroup="{record}">
        {{ record.user.group.groupname }}
      </template>
      <template #usertype="{ record }">
        <a-tag v-if="record.usertype.includes('00')" color="blue">{{ $t("user.normalUser") }}</a-tag>
        <a-tag v-if="record.usertype.includes('01')" color="green">{{ $t("user.labAdmin") }}</a-tag>
        <a-tag v-if="record.usertype.includes('02')" color="cyan">{{ $t("user.PI") }}</a-tag>
        <a-tag v-if="record.usertype.includes('99')" color="purple">{{ $t("user.adminUser") }}</a-tag>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status === '00'" color="orange">{{ $t("user.waitPass") }}</a-tag>
        <a-tag v-if="record.status === '01'" color="#108ee9">{{ $t("user.normal") }}</a-tag>
        <a-tag v-if="record.status === '09'" color="#f50">{{ $t("user.band") }}</a-tag>
      </template>
      <template #starttime="{ record }">
        {{ formatDate(record.starttime) }}
      </template>
      <template #endtime="{ record }">
        {{ formatDate(record.endtime) }}
      </template>
      <template #operation="{ record }">
        <a-button size="small" v-if="record.status === '00'" @click="passVisit(record.id)">{{
            $t("user.pass")
          }}
        </a-button>
        <edit-visit :visit-id="record.id" @change="initPage"></edit-visit>
      </template>
    </a-table>
    <v-loading :show="loading"></v-loading>
  </div>
</template>

<script>
import util from "@/util/util";
import VLoading from "@/components/public/v-loading";
import EditVisit from "@/components/admin/editVisit";
import AddNewUser from "@/components/admin/addNewUser";

export default {
  name: "userManage",
  components: {
    AddNewUser,
    EditVisit,
    VLoading,
  },
  data() {
    return {
      cols: [],
      visitList: [],
      searchInput: {},
      loading: false,
      state: {
        searchText: '',
        searchedColumn: '',
      }
    }
  },
  mounted() {
    this.initPage();
    this.initCols();
  },
  methods: {
    passVisit(visitId) {
      var post = {
        visitId: visitId
      }
      var that = this;
      util.$post("/admin/userManage/passUser", post, function () {
        that.initPage();
      }, this.maskShow, this.maskHide);
    },
    formatDate(val) {
      if (util.isNull(val)) {
        return "";
      } else {
        return util.dateFormat(val, "YYYY-MM-DD");
      }
    },
    maskShow() {
      this.loading = true;
    },
    maskHide() {
      this.loading = false;
    },
    initPage() {
      var that = this;
      util.$post("/admin/userManage/init", {}, function (retMap) {
        that.visitList = retMap.visitList;
      }, this.maskShow, this.maskHide);
    },
    initCols() {
      var cols = new Array();
      cols.push({
        title: this.$t("index"),
        key: "index",
        slots: {
          customRender: 'index',
        },
        width: "5%",
      })

      cols.push({
        title: this.$t("user.name"),
        dataIndex: 'userName',
        key: 'userName',
        slots: {
          customRender: 'userName',
        },
      })

      cols.push({
        title: this.$t("user.group"),
        dataIndex: 'userGroup',
        key: 'userGroup',
        slots: {
          customRender: 'userGroup',
        },
      })

      cols.push({
        title: this.$t("phone"),
        dataIndex: 'phone',
        key: 'phone',
        slots: {
          customRender: 'phone',
        },
      })

      cols.push({
        title: this.$t("user.usertype"),
        dataIndex: 'usertype',
        key: 'usertype',
        width: "20%",
        slots: {
          customRender: 'usertype',
        },
      })

      cols.push({
        title: this.$t("operation"),
        dataIndex: 'operation',
        key: 'operation',
        slots: {
          customRender: 'operation',
        },
      })

      this.cols = cols;
    },

    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.state.searchText = selectedKeys[0];
      this.state.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.state.searchText = '';
    }
  }
}
</script>

<style scoped>

</style>